'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Welcome = require('@/components/startups/Welcome');

var _Welcome2 = _interopRequireDefault(_Welcome);

var _CommonLayout = require('@/customized-core/startups/CommonLayout.vue');

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

console.log("Source 2.");

exports.default = {
    mixins: [_Welcome2.default],
    created: function created() {
        var options = _state2.default.settings.startupOptions;

        var previousNet = null;
        if (options.server.trim()) {
            previousNet = _state2.default.getNetworkFromAddress(options.server.trim());
        }

        if (Misc.queryStringVal('nick')) {
            this.nick = Misc.queryStringVal('nick');
        } else if (previousNet && previousNet.connection.nick) {
            this.nick = previousNet.connection.nick;
        } else {
            this.nick = options.nick;
        }

        this.nick = this.processNickRandomNumber(this.nick || '');

        if (Misc.queryStringVal('channel')) {

            this.channel = Misc.queryStringVal('channel');
        } else if (previousNet && previousNet.connection.nick) {
            this.channel = previousNet.connection.nick;
        } else {
            this.channel = options.nick;
        }

        this.channel = this.processNickRandomNumber(this.channel || '');
        this.password = options.password || '';
        this.channel = decodeURIComponent(window.location.hash) || options.channel || '';

        this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
        this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
        this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
        this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;

        this.connectWithoutChannel = !!options.allowNoChannel;

        if (options.bouncer) {
            this.toggablePass = false;
            this.showPass = true;
            this.showChannel = false;
            this.connectWithoutChannel = true;

            var bouncer = new BouncerProvider(this.$state);
            bouncer.enable(options.server, options.port, options.tls, options.direct, options.path);
        }

        if (options.autoConnect && this.nick && (this.channel || this.connectWithoutChannel)) {
            this.startUp();
        }

        this.recaptchaSiteId = options.recaptchaSiteId || '';
    },

    components: {
        StartupLayout: _CommonLayout2.default
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/startups/Welcome.vue
// module id = OlOA
// module chunks = 1